import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ComponentVariantModel } from '@models/component-variant';
import { ConfigurationModel } from '@models/configuration';
import { ConfigurationPlusModel } from '../../../../_models/configuration-plus-model';
import { ConfigurationViewModel } from '../../../../_models/configuration-view-model';
import { ModelGroupModel } from './../../../../_models/model-group';
import { ConfigurationItemComponent } from './configuration-item/configuration-item';

@Component({
	selector: 'configuration-list',
	templateUrl: 'configuration-list.html',
	styleUrls: ['./configuration-list.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [ConfigurationItemComponent, CommonModule]
})
export class ConfigurationListComponent implements OnChanges {

	@Input() modelGroup: ModelGroupModel;
	@Input() configs: Array<ConfigurationViewModel>;
	@Input() image: (conf: any) => string;
	@Input() selected: ConfigurationModel | null;
	@Input() editMode: boolean;
	@Input() chosenVariants: Array<ComponentVariantModel>;
	@Input() variantOrModelIsNew: boolean = false;
	@Input() scrollPosition: number;
	@Output() scrollPositionChange = new EventEmitter<number>();

	@Output() selectedChange = new EventEmitter<ConfigurationPlusModel>();

	ngOnChanges(changes: SimpleChanges) {
		if (this.configs && this.configs.length > 0) {
			this.configs.forEach(config => {
				if (this.modelGroup.IsConfigurationBased) {
					if (config.configurationModel.configurationModel.ModelConfigurationCode == this.selected?.ModelConfigurationCode) {
						config.selected = true;
					}
					else {
						config.selected = false;
					}
				}
				else {
					let configSelected = true;
					config.configurationModel.variants.forEach(variantOnConfig => {
						const variantFound = this.chosenVariants.filter(x => x.VariantColor && x.VariantColor.Color)
							.find(x => x.Component.Code == variantOnConfig.Component.Code && x.VariantColor?.Color?.Code == variantOnConfig.VariantColor?.Color?.Code);

						if (!variantFound) {
							configSelected = false;
						}
					});

					config.selected = configSelected;
				}
			});
		}
	}

	setSelected(selected: ConfigurationViewModel) {
		this.selectedChange.emit(selected.configurationModel);
	}

	updatePosition(pos: any) {
		this.scrollPositionChange.emit(pos);
	}

}
